import React, { useState, useEffect } from 'react';
import styles from './viewCandidates.module.scss';
import { Alert, Card, Col, Dropdown, DropdownButton, Row, Form, Modal, Container } from 'react-bootstrap';
import MaterialTable from "material-table";
import { useParams, useHistory } from 'react-router-dom';
import CSSLoader from '../../../../shared/cssLoader';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import CustomNavbar from '../../../customNavbar';
import { dropdownIcon, eyeClose, eyeOpen } from '../../../../shared/customIcons/Icons';
import { createMuiTheme, Icon, MuiThemeProvider } from '@material-ui/core';
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Formik } from 'formik';
import { CustomButton } from '../../../../shared/customButton';
import { getAllPipelineList, getCandidateFilters, getFilteredCandidates } from '../../../../../services/util/hiringpipeline/candidateFilter';
import { toast } from 'react-toastify';
import { failCandidateManually, failFilteredCandidates, markAsOfferSentAPI, passCandidateManually, getCandidateDetails, passFailedCandidateManually, candidateRejectOffer, markAsCandidateHired } from '../../../../../services/util/hiringpipeline/candidates';
import { CustomConfirmationBox } from '../../../../shared/customConfirmationBox';
import { CustomConfirmationModal } from '../../../../shared/customConfirmationModal';
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import SendBulkEmailsToCandidates from '../../../common/sendBulkEmailsToCandidates/index';
import { checkCompanyEmailAccountConnection } from '../../../../../services/util/company';

const ViewCandidates = (props) => {
    const animatedComponents = makeAnimated();
    let concatValue;
    let [filteredtableData, setFilteredTableData] = useState([]);

    let [isPageLoading, setPageLoading] = useState(false); // loading entire page (when pipeline change)
    let [isDataLoading, setDateLoading] = useState(false); // loading candidate table data
    let [isFilterSettingsLoading, setFilterSettingLoading] = useState(false); // loading filter settings

    // filter objects
    let [rootFilterSettingsObj, setRootFilterSettingsObj] = useState({}); // root level filter object
    let [filterLevelOneObj, setFilterLevelOneObj] = useState({});
    let [filterLevelTwoObj, setFilterLevelTwoObj] = useState({});
    let [filterLevelThreeObj, setFilterLevelThreeObj] = useState({});


    let [selectedFilterLevelOneDropDownObj, setSelectedFilterLevelOneDropDownObj] = useState(null); // level one filter object
    let [selectedFilterLevelTwoDropDownObj, setSelectedFilterLevelTwoDropDownObj] = useState(null); // level two  filter object
    let [selectedFilterLevelThreeDropDownObj, setSelectedFilterLevelThreeDropDownObj] = useState(null); // level three  filter object

    // drop down objects arrays for filters
    let [pipelineListDropDownArray, setPipelineListDropDownArray] = useState({});
    let [filterLevelOneDropDownArray, setFilterLevelOneDropDownArray] = useState([]);
    let [filterLevelTwoDropDownArray, setFilterLevelTwoDropDownArray] = useState([]);
    let [filterLevelThreeDropDownArray, setFilterLevelThreeDropDownArray] = useState([]);


    let [isLevelOneFilterError, setLevelOneFilterError] = useState(false);
    let [isLevelTwoFilterError, setLevelTwoFilterError] = useState(false);
    let [isLevelThreeFilterError, setLevelThreeFilterError] = useState(false);


    let [currentPipelineObj, setCurrentPipelineObj] = useState({});


    let [isFilterLevelTwoAvailable, setFilterLevelTwoAvailable] = useState(false);
    let [isFilterLevelThreeAvailable, setFilterLevelThreeAvailable] = useState(false);

    let [isURLLoading, setURLLoading] = useState(false);

    let [showBulkEmailsToCandidates, setShowBulkEmailsToCandidates] = useState(false);
    let [isLoading, setLoading] = useState(false);

    //table action states
    let [tableActions, setTableActions] = useState([]);

    const history = useHistory();
    //getting the pipelineID
    let { id } = useParams();
    let selected_pipeline_id = id;


    let [currentPipelineId, setCurrentPipelineId] = useState(selected_pipeline_id);

    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let filter_level_one_url_paramater = (params.get('filter_level_one') == 'null') ? null : params.get('filter_level_one');
    let filter_level_two_url_paramater = (params.get('filter_level_two') == 'null') ? null : params.get('filter_level_two');
    let filter_level_three_url_paramater = (params.get('filter_level_three') == 'null') ? null : params.get('filter_level_three');

    let [candidateData, setCandidateData] = useState();

    // Action codes
    // Evaluation Stages
    const MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION = '10';
    const MANUALLY_REJECT_IN_EVALUATION = '20';
    const MANUALLY_PASS_FROM_FAILED_IN_EVALUATION = '30';
    // Filtered Stage
    const MARK_AS_OFFER_SENT_IN_FILTERD_STAGE = '110';
    const REJECT_IN_FILTERD_STAGE = '120';
    //Offer sent stage
    const MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE = '210';
    const MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE = '220';

    const SEND_BULK_EMAILS = '100';

    //Actions Modal states
    let [actionStateModal, setActionStateModal] = useState({
        is_open: false,
        candidate_id_set: [],
        action_state: ''
    });

    //Actions Submit Loading
    let [actionsSubmitLoading, setActionsSubmitLoading] = useState(false);

    //breadcrumb object
    const breadcrumb = [
        {
            pathaddress: '/app/company/pipelines',
            pathname: 'Hiring Pipelines',
            isActive: false,
            key: 4 + 'Hiring Pipeline'
        },
        {
            pathaddress: `/app/company/pipelines/${selected_pipeline_id}`,
            pathname: rootFilterSettingsObj.pipeline_name,
            isActive: false,
            key: 1 + rootFilterSettingsObj.pipeline_name
        },
        {
            pathaddress: ``,
            pathname: 'Filter Candidates',
            isActive: true,
            key: 1 + 'Filter'
        },
    ]

    //load page data function (initial call)
    const loadPageData = async () => {

        if (currentPipelineId) {
            setPageLoading(true);

            let respond = await getAllPipelineList(selected_pipeline_id);
            if (respond.success === true) {

                //main pipeline data object (label / value data set) assign to state (comming from the backend as key, value objects. so no need to format)
                setPipelineListDropDownArray(respond.data);


            } else {
                setPageLoading(false);
                history.push(`/app/company/pipelines/${selected_pipeline_id}`);
            }
        }
    }

    const changeSelectedPipeline = async (selected_pipeline_id) => {
        history.push({
            pathname: `/app/company/pipelines/${selected_pipeline_id}/candidates`,
            search: `?filter_level_one=null&filter_level_two=null&filter_level_three=null`
        });
    }

    //load availeble filter settings of the pipeline
    const loadPipelineFilterSettings = async (selected_pipeline_id) => {

        if (pipelineListDropDownArray.length > 0) {

            setPageLoading(true);
            let selectedPipelineObjArray = (pipelineListDropDownArray).filter(function (el) {
                return el.value === selected_pipeline_id;
            });
            setCurrentPipelineObj(selectedPipelineObjArray[0]);

            setSelectedFilterLevelOneDropDownObj(null);
            setSelectedFilterLevelTwoDropDownObj(null);
            setSelectedFilterLevelThreeDropDownObj(null);

            setFilterLevelOneDropDownArray([]);
            setFilterLevelTwoDropDownArray([]);
            setFilterLevelThreeDropDownArray([]);

            // setFilterLevelThreeAvailable(false);
            // setFilterLevelTwoSettingsObj([]);
            // setFilterLevelThreeSettingsObj([]);

            let getCandidateFiltersRespond = await getCandidateFilters(selected_pipeline_id);
            if (getCandidateFiltersRespond.success === true) {
                setRootFilterSettingsObj(getCandidateFiltersRespond.data);


                //pass boolean value to identify the function of set URL parameter values as current objects
                setFilterLevelOneData(getCandidateFiltersRespond.data);
                getAllCandidatesByFilter();

                setPageLoading(false);
            } else {
                setPageLoading(false);
                history.push(`/app/company/pipelines/${selected_pipeline_id}`);
            }
        }

    }

    const setFilterLevelOneData = () => {

        if (rootFilterSettingsObj && rootFilterSettingsObj.filters) {

            setSelectedFilterLevelTwoDropDownObj(null);
            setSelectedFilterLevelThreeDropDownObj(null);

            setFilterLevelTwoDropDownArray([]);
            setFilterLevelThreeDropDownArray([]);

            setFilterLevelTwoAvailable(false);
            setFilterLevelThreeAvailable(false);

            setLevelOneFilterError(false);

            setTableActions([]);

            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_one_filters = rootFilterSettingsObj.filters;
            let filter_level_one_array = [];

            let selected_filter_level_one_drop_down_obj = null;
            let selected_filter_level_one_obj = null;


            for (let index = 0; index < level_one_filters.length; index++) {
                let filterObj = {
                    label: level_one_filters[index].filter_label,
                    value: level_one_filters[index].filter_id
                }
                filter_level_one_array.push(filterObj);

                if (filter_level_one_url_paramater && (level_one_filters[index].filter_id == filter_level_one_url_paramater)) {
                    selected_filter_level_one_obj = level_one_filters[index];
                    selected_filter_level_one_drop_down_obj = filterObj;

                    if (selected_filter_level_one_obj.is_nested_filters_available) {
                        setFilterLevelTwoAvailable(true);
                    }
                    if (selected_filter_level_one_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_one_obj.action_list);
                    }
                }
            }

            setTableActions([]);

            //set selected filter level one obj
            setFilterLevelOneObj(selected_filter_level_one_obj)

            //set filter level one array object (label / value data set) to a state
            setFilterLevelOneDropDownArray(filter_level_one_array);
            // set selected filter level one drop down object
            setSelectedFilterLevelOneDropDownObj(selected_filter_level_one_drop_down_obj);
        }

    }

    //on change filter one dropdown
    const changeFilterLevelOne = (selected_filter_level_one) => {

        if (rootFilterSettingsObj && rootFilterSettingsObj.filters) {

            //reset future filters

            filter_level_one_url_paramater = null;
            filter_level_two_url_paramater = null;
            filter_level_three_url_paramater = null;

            setSelectedFilterLevelTwoDropDownObj(null);
            setSelectedFilterLevelThreeDropDownObj(null);

            setFilterLevelTwoDropDownArray([]);
            setFilterLevelThreeDropDownArray([]);

            setFilterLevelTwoAvailable(false);
            setFilterLevelThreeAvailable(false);

            setLevelOneFilterError(false);

            setTableActions([]);



            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_one_filters = rootFilterSettingsObj.filters;

            let selected_filter_level_one_drop_down_obj = null;
            let selected_filter_level_one_obj = null;


            for (let index = 0; index < level_one_filters.length; index++) {

                if (selected_filter_level_one && (level_one_filters[index].filter_id == selected_filter_level_one)) {

                    selected_filter_level_one_obj = level_one_filters[index];

                    let filterObj = {
                        label: level_one_filters[index].filter_label,
                        value: level_one_filters[index].filter_id
                    }
                    selected_filter_level_one_drop_down_obj = filterObj;

                    if (selected_filter_level_one_obj.is_nested_filters_available) {
                        setFilterLevelTwoAvailable(true);
                    }
                    if (selected_filter_level_one_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_one_obj.action_list);
                    }
                    break;
                }
            }

            //set selected filter level one obj
            setFilterLevelOneObj(selected_filter_level_one_obj)

            // set selected filter level one drop down object
            setSelectedFilterLevelOneDropDownObj(selected_filter_level_one_drop_down_obj);

        }


    }


    const setFilterLevelTwoData = () => {

        if (filterLevelOneObj && filterLevelOneObj.is_nested_filters_available && filterLevelOneObj.filters) {

            setFilterLevelThreeAvailable(false);
            setTableActions([]);

            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_two_filters = filterLevelOneObj.filters;
            let filter_level_two_array = [];

            let selected_filter_level_two_drop_down_obj = null;
            let selected_filter_level_two_obj = null;


            for (let index = 0; index < level_two_filters.length; index++) {
                let filterObj = {
                    label: level_two_filters[index].filter_label,
                    value: level_two_filters[index].filter_id
                }
                filter_level_two_array.push(filterObj);

                if (filter_level_two_url_paramater && (level_two_filters[index].filter_id == filter_level_two_url_paramater)) {

                    selected_filter_level_two_obj = level_two_filters[index];
                    selected_filter_level_two_drop_down_obj = filterObj;

                    if (selected_filter_level_two_obj.is_nested_filters_available) {
                        setFilterLevelThreeAvailable(true);
                    }
                    if (selected_filter_level_two_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_two_obj.action_list);
                    }
                }
            }

            //set selected filter level one obj
            setFilterLevelTwoObj(selected_filter_level_two_obj)

            //set filter level one array object (label / value data set) to a state
            setFilterLevelTwoDropDownArray(filter_level_two_array);
            // set selected filter level one drop down object
            setSelectedFilterLevelTwoDropDownObj(selected_filter_level_two_drop_down_obj);

            //pass boolean value to identify the function of set URL parameter values as current objects
            // setFilterLevelThreeData();
        }

    }


    //on change filter one dropdown
    const changeFilterLevelTwo = (selected_filter_level_two) => {

        if (filterLevelOneObj && filterLevelOneObj.filters) {

            filter_level_two_url_paramater = null;
            filter_level_three_url_paramater = null;

            //reset future filters
            setSelectedFilterLevelThreeDropDownObj(null);
            setFilterLevelThreeDropDownArray([]);

            setLevelTwoFilterError(false);

            setFilterLevelThreeAvailable(false);
            setTableActions([]);


            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_two_filters = filterLevelOneObj.filters;

            let selected_filter_level_two_drop_down_obj = null;
            let selected_filter_level_two_obj = null;


            for (let index = 0; index < level_two_filters.length; index++) {

                if (selected_filter_level_two && (level_two_filters[index].filter_id == selected_filter_level_two)) {

                    selected_filter_level_two_obj = level_two_filters[index];

                    let filterObj = {
                        label: level_two_filters[index].filter_label,
                        value: level_two_filters[index].filter_id
                    }
                    selected_filter_level_two_drop_down_obj = filterObj;

                    if (selected_filter_level_two_obj.is_nested_filters_available) {
                        setFilterLevelThreeAvailable(true);
                    }
                    if (selected_filter_level_two_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_two_obj.action_list);
                    }
                    break;
                }
            }

            //set selected filter level one obj
            setFilterLevelTwoObj(selected_filter_level_two_obj)

            // set selected filter level one drop down object
            setSelectedFilterLevelTwoDropDownObj(selected_filter_level_two_drop_down_obj);
        }

    }


    const setFilterLevelThreeData = () => {

        if (filterLevelTwoObj && filterLevelTwoObj.is_nested_filters_available && filterLevelTwoObj.filters) {

            setTableActions([]);

            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_three_filters = filterLevelTwoObj.filters;
            let filter_level_three_array = [];

            let selected_filter_level_three_drop_down_obj = null;
            let selected_filter_level_three_obj = null;


            for (let index = 0; index < level_three_filters.length; index++) {
                let filterObj = {
                    label: level_three_filters[index].filter_label,
                    value: level_three_filters[index].filter_id
                }
                filter_level_three_array.push(filterObj);

                if (filter_level_three_url_paramater && (level_three_filters[index].filter_id == filter_level_three_url_paramater)) {
                    selected_filter_level_three_obj = level_three_filters[index];
                    selected_filter_level_three_drop_down_obj = filterObj;

                    if (selected_filter_level_three_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_three_obj.action_list);
                    }
                }

            }

            //set selected filter level one obj
            setFilterLevelThreeObj(selected_filter_level_three_obj)

            //set filter level one array object (label / value data set) to a state
            setFilterLevelThreeDropDownArray(filter_level_three_array);
            // set selected filter level one drop down object
            setSelectedFilterLevelThreeDropDownObj(selected_filter_level_three_drop_down_obj);
        }

    }


    //on change filter one dropdown
    const changeFilterLevelThree = (selected_filter_level_three) => {

        if (filterLevelTwoObj && filterLevelTwoObj.filters) {

            filter_level_three_url_paramater = null;

            setLevelThreeFilterError(false);
            setTableActions([]);

            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_three_filters = filterLevelTwoObj.filters;

            let selected_filter_level_three_drop_down_obj = null;
            let selected_filter_level_three_obj = null;


            for (let index = 0; index < level_three_filters.length; index++) {

                if (selected_filter_level_three && (level_three_filters[index].filter_id == selected_filter_level_three)) {

                    selected_filter_level_three_obj = level_three_filters[index];

                    let filterObj = {
                        label: level_three_filters[index].filter_label,
                        value: level_three_filters[index].filter_id
                    }
                    selected_filter_level_three_drop_down_obj = filterObj;

                    if (selected_filter_level_three_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_three_obj.action_list);
                    }

                    break;
                }
            }

            //set selected filter level one obj
            setFilterLevelThreeObj(selected_filter_level_three_obj)

            // set selected filter level one drop down object
            setSelectedFilterLevelThreeDropDownObj(selected_filter_level_three_drop_down_obj);
        }
    }

    useEffect(() => {
        loadPipelineFilterSettings(selected_pipeline_id)
    }, [pipelineListDropDownArray, selected_pipeline_id]);


    useEffect(() => {
        setFilterLevelOneData()
    }, [rootFilterSettingsObj]);


    useEffect(() => {
        setFilterLevelTwoData()
    }, [filterLevelOneObj]);

    useEffect(() => {
        setFilterLevelThreeData()
    }, [filterLevelTwoObj]);





    //view candidate
    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    //load all candidates according to filter parameters
    const getAllCandidatesByFilter = async () => {


        if (filter_level_one_url_paramater) {
            setDateLoading(true)
            let respond = await getFilteredCandidates(selected_pipeline_id, filter_level_one_url_paramater ? filter_level_one_url_paramater : null, filter_level_two_url_paramater ? filter_level_two_url_paramater : null, filter_level_three_url_paramater ? filter_level_three_url_paramater : null);
            if (respond.success === true) {
                setFilteredTableData(respond.data);
                setDateLoading(false)
            } else {
                setDateLoading(false)
                history.push(`/app/company/pipelines/${selected_pipeline_id}`)
            }
        }
    }

    //Material data table change theme color
    const theme = createMuiTheme({
        palette: {
            primary: {
                main: '#24859A',
            },
            secondary: {
                main: '#24859A',
            },
        },

    });

    //Add maximum length to  value and add 3 dots
    function addMaxViewLength(values, size) {
        concatValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }



    //on click filter button
    const onSubmitFilter = async (values) => {


        let filter_one = values.filter_level_one ? values.filter_level_one.value : null;
        let filter_two = values.filter_level_two ? values.filter_level_two.value : null;
        let filter_three = values.filter_level_three ? values.filter_level_three.value : null;

        if (!filter_one) {
            setLevelOneFilterError(true)
        }
        else if (!filter_two && filterLevelOneObj && filterLevelOneObj.is_nested_filter_required) {
            setLevelTwoFilterError(true)
        }
        else if (!filter_three && filterLevelTwoObj && filterLevelTwoObj.is_nested_filter_required) {
            setLevelThreeFilterError(true)
        }
        else {
            selected_pipeline_id = values.pipeline.value;
            history.replace(`${selected_pipeline_id}/candidates` + (filter_one && filter_two && filter_three) ? `?filter_level_one=${filter_one}&filter_level_two=${filter_two}&filter_level_three=${filter_three}` : (filter_one && filter_two && !filter_three) ? `?filter_level_one=${filter_one}&filter_level_two=${filter_two}` : '');
        }

    }

    //on action selected
    const onActionSelected = async (action_id, data_values) => {
        let candidate_id_array = [];
        let candidate_data_array = [];
        //loop to get candidate ids
        for (let index = 0; index < data_values.length; index++) {
            candidate_id_array.push(data_values[index].id);
        }

        if (action_id === MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION
            });
        }
        if (action_id === MANUALLY_REJECT_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_REJECT_IN_EVALUATION
            });
        }
        if (action_id === MANUALLY_PASS_FROM_FAILED_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_PASS_FROM_FAILED_IN_EVALUATION
            });
        }

        if (action_id === REJECT_IN_FILTERD_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: REJECT_IN_FILTERD_STAGE
            });
        }

        if (action_id === SEND_BULK_EMAILS) {
            setShowBulkEmailsToCandidates(true);
            for (let index = 0; index < data_values.length; index++) {
                let candidate_object = {
                    candidate_id: data_values[index].id,
                    candidate_email: data_values[index].email,
                }
                candidate_data_array.push(candidate_object);
            }
            setCandidateData(candidate_data_array);
        }
    };

    //pass candidates to next evaluation step
    const manualPassToNextStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await passCandidateManually(actionStateModal.candidate_id_set, selectedFilterLevelTwoDropDownObj.value, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            props.GetTaskValues();
            loadPageData();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //failcandidates from current pipeline step
    const manuallyFailFromCurrentStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await failCandidateManually(actionStateModal.candidate_id_set, selectedFilterLevelTwoDropDownObj.value, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            props.GetTaskValues();
            loadPageData();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //manually pass failed candidate to next step
    const manuallyPassFailedCandidateFromStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await passFailedCandidateManually(actionStateModal.candidate_id_set, selectedFilterLevelTwoDropDownObj.value, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            props.GetTaskValues();
            loadPageData();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //manually fail from filter step
    const manuallyFailFromFilterStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await failFilteredCandidates(actionStateModal.candidate_id_set, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            props.GetTaskValues();
            loadPageData();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    const handleClose = () => {
        setShowBulkEmailsToCandidates(false);
    };

    useEffect(() => {
        loadPageData();
    }, [currentPipelineId]);

    useEffect(() => {
        let pageHit = '';
        pageHit = '/app/company/pipeline/filter_candidates';
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])

    return (
        <div>
            <Helmet>
                <title>View Candidates | HireTrace</title>
            </Helmet>
            {isPageLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>

                    {/* Manually pass pipeline step confirmation popup box start */}
                    <CustomConfirmationBox
                        show={actionStateModal.is_open && actionStateModal.action_state === MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION}
                        cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onFormSubmit={manualPassToNextStep}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to manually pass selected candidate(s) from current stage to the next stage."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, pass step!"
                        checkboxLabel="I confirm to manually pass selected candidate(s) from pipeline step"
                    />
                    {/* Manually pass pipeline step confirmation popup box end */}

                    {/* Manually fail pipeline step confirmation popup box start */}
                    <CustomConfirmationBox
                        show={actionStateModal.is_open && actionStateModal.action_state === MANUALLY_REJECT_IN_EVALUATION}
                        cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onFormSubmit={manuallyFailFromCurrentStep}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to manually reject selected candidate(s) from the pipeline. Candidate(s) overall status will be failed"
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, reject candidate"
                        checkboxLabel="I confirm to manually reject selected candidate(s) from the pipeline"
                    />
                    {/* Manually fail pipeline step confirmation popup box end */}

                    {/* Manually pass failed candidate confirmation box start */}
                    <CustomConfirmationBox
                        show={actionStateModal.is_open && actionStateModal.action_state === MANUALLY_PASS_FROM_FAILED_IN_EVALUATION}
                        cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onFormSubmit={manuallyPassFailedCandidateFromStep}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to manually pass selected candidate(s) from current stage to the next stage."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, pass step!"
                        checkboxLabel="I confirm to manually pass selected candidate(s) from pipeline step"
                    />
                    {/* Manually pass failed candidate confirmation box end */}

                    {/* Manually fail from filter step confirmation popup box start */}
                    <CustomConfirmationBox
                        show={actionStateModal.is_open && actionStateModal.action_state === REJECT_IN_FILTERD_STAGE}
                        cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onFormSubmit={manuallyFailFromFilterStep}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to manually reject selected candidate(s) from the pipeline. Candidate(s) overall status will be failed"
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, reject candidate"
                        checkboxLabel="I confirm to manually reject selected candidate(s) from the pipeline"
                    />
                    {/* Manually fail from filter step confirmation popup box end */}

                    {/* {
                    isSendEmailLoading === false && showBulkEmailsToCandidates ?

                    <SendBulkEmailsToCandidates showModal={showBulkEmailsToCandidates} handleClose= {handleClose} candidateData={candidateData} loadPageData = {loadPageData}/>

                            : (<div className='mt-5'>
                            <Col sm={{ span: 4, offset: 4 }}>
                                <CSSLoader />
                            </Col>
                            </div>)
                    } */}

                    {showBulkEmailsToCandidates &&
                        <SendBulkEmailsToCandidates showModal={showBulkEmailsToCandidates} handleClose={handleClose} candidateData={candidateData} loadPageData={loadPageData} />
                    }

                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                        <Col className={styles.settingsOuterBox}>
                            <Formik
                                enableReinitialize
                                onSubmit={(values) => onSubmitFilter(values)}
                                initialValues={{ pipeline: currentPipelineObj, filter_level_one: selectedFilterLevelOneDropDownObj, filter_level_two: selectedFilterLevelTwoDropDownObj, filter_level_three: selectedFilterLevelThreeDropDownObj }}>

                                {({
                                    values,
                                    errors,
                                    handleChange,
                                    handleSubmit,
                                    setFieldValue,
                                    submitCount
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Row className="mt-2 mb-2">
                                            <Col lg={5} className="mb-2">
                                                <Card className={styles.mainCard}>
                                                    <Card.Header className={styles.cardHeader}>Pipeline Details</Card.Header>
                                                    <Card.Body className={styles.cardBody}>
                                                        <Row>
                                                            <Col sm={5}>
                                                                <p className={styles.defaultLabel}>Pipeline Name</p>
                                                            </Col>
                                                            <Col>
                                                                <Select
                                                                    options={pipelineListDropDownArray}
                                                                    name="pipeline"
                                                                    class="react-select__control"
                                                                    components={animatedComponents}
                                                                    value={values.pipeline}
                                                                    onChange={(e) => { changeSelectedPipeline(e.value); setFieldValue('pipeline', e.value) }}
                                                                    styles={
                                                                        {
                                                                            ...styles,
                                                                            control: (base, state) => ({
                                                                                ...base,
                                                                                '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                                border: '1px solid #bdbdbd', // default border color
                                                                                borderRadius: '6px',
                                                                                boxShadow: 'none', // no box-shadow
                                                                                fontFamily: 'var(--app-primary-font-style)',
                                                                                fontWeight: 'var(--app-regular-font-weight)',
                                                                                fontSize: 'var(--app-semi-small-font-size)'
                                                                            }),
                                                                            option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                return {
                                                                                    ...styles,
                                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                                    fontWeight: 'var(--app-regular-font-weight)',
                                                                                    fontSize: 'var(--app-semi-small-font-size)',
                                                                                    background: isDisabled
                                                                                        ? null
                                                                                        : isSelected
                                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                                            : isFocused
                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                : null,
                                                                                    color: isDisabled
                                                                                        ? '#ccc'
                                                                                        : isSelected
                                                                                            ? '#24859A'
                                                                                            : '#24859A',
                                                                                    cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                    ':active': {
                                                                                        ...styles[':active'],
                                                                                        background:
                                                                                            !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                    },
                                                                                };
                                                                            },
                                                                        }
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>

                                                        <Row className='mt-4'>
                                                            <Col sm={5}><p className={styles.cardTopic}>Position</p></Col>
                                                            <Col><p className={styles.cardData}>{rootFilterSettingsObj.position}</p></Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col lg={7}>
                                                <Card className={styles.mainCard}>
                                                    <Card.Header className={styles.cardHeader}>Filters</Card.Header>
                                                    {isFilterSettingsLoading ?
                                                        <Col sm={{ span: 4, offset: 4 }} className="p-4">
                                                            <CSSLoader />
                                                        </Col>
                                                        :
                                                        <Card.Body className={styles.cardBody}>
                                                            <Row>
                                                                <Col>
                                                                    <Row>
                                                                        <Col lg={3}>
                                                                            <p className={styles.defaultLabel}>Stage</p>
                                                                            {isLevelOneFilterError && <p className={styles.errorMsg}>Required</p>}
                                                                        </Col>
                                                                        <Col>
                                                                            <Select
                                                                                options={filterLevelOneDropDownArray}
                                                                                name="filter_level_one"
                                                                                class="react-select__control"
                                                                                components={animatedComponents}
                                                                                value={values.filter_level_one}
                                                                                onChange={(e) => { changeFilterLevelOne(e.value); setFieldValue('filter_level_one', e.value) }}
                                                                                styles={
                                                                                    isLevelOneFilterError ?
                                                                                        {
                                                                                            ...styles,
                                                                                            control: (base, state) => ({
                                                                                                ...base,
                                                                                                '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                                                                border: '1px solid #dc3545', // default border color
                                                                                                borderRadius: '6px',
                                                                                                boxShadow: 'none', // no box-shadow
                                                                                            }),
                                                                                            option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                                return {
                                                                                                    ...styles,
                                                                                                    background: isDisabled
                                                                                                        ? null
                                                                                                        : isSelected
                                                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                                                            : isFocused
                                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                : null,
                                                                                                    color: isDisabled
                                                                                                        ? '#ccc'
                                                                                                        : isSelected
                                                                                                            ? '#24859A'
                                                                                                            : '#24859A',
                                                                                                    cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                                    ':active': {
                                                                                                        ...styles[':active'],
                                                                                                        background:
                                                                                                            !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                                    },
                                                                                                };
                                                                                            },
                                                                                        }
                                                                                        :
                                                                                        {
                                                                                            ...styles,
                                                                                            control: (base, state) => ({
                                                                                                ...base,
                                                                                                '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                                                border: '1px solid #bdbdbd', // default border color
                                                                                                borderRadius: '6px',
                                                                                                boxShadow: 'none', // no box-shadow
                                                                                                fontFamily: 'var(--app-primary-font-style)',
                                                                                                fontWeight: 'var(--app-regular-font-weight)',
                                                                                                fontSize: 'var(--app-semi-small-font-size)'
                                                                                            }),
                                                                                            option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                                return {
                                                                                                    ...styles,
                                                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                                                    fontWeight: 'var(--app-regular-font-weight)',
                                                                                                    fontSize: 'var(--app-semi-small-font-size)',
                                                                                                    background: isDisabled
                                                                                                        ? null
                                                                                                        : isSelected
                                                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                                                            : isFocused
                                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                : null,
                                                                                                    color: isDisabled
                                                                                                        ? '#ccc'
                                                                                                        : isSelected
                                                                                                            ? '#24859A'
                                                                                                            : '#24859A',
                                                                                                    cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                                    ':active': {
                                                                                                        ...styles[':active'],
                                                                                                        background:
                                                                                                            !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                                    },
                                                                                                };
                                                                                            },
                                                                                        }
                                                                                }
                                                                            />

                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col>
                                                                    {isFilterLevelThreeAvailable &&
                                                                        <Row>
                                                                            <Col lg={3}>
                                                                                <p className={styles.defaultLabel}>FIlter 2</p>
                                                                                {isLevelThreeFilterError && <p className={styles.errorMsg}>Required</p>}
                                                                            </Col>
                                                                            <Col>
                                                                                <Select
                                                                                    options={filterLevelThreeDropDownArray}
                                                                                    name="filter_level_three"
                                                                                    class="react-select__control"
                                                                                    components={animatedComponents}
                                                                                    value={values.filter_level_three}
                                                                                    onChange={(e) => { changeFilterLevelThree(e.value); setFieldValue('filter_level_three', e.value) }}
                                                                                    styles={
                                                                                        isLevelThreeFilterError ?
                                                                                            {
                                                                                                ...styles,
                                                                                                control: (base, state) => ({
                                                                                                    ...base,
                                                                                                    '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                                                                    border: '1px solid #dc3545', // default border color
                                                                                                    borderRadius: '6px',
                                                                                                    boxShadow: 'none', // no box-shadow
                                                                                                }),
                                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                                    return {
                                                                                                        ...styles,
                                                                                                        background: isDisabled
                                                                                                            ? null
                                                                                                            : isSelected
                                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                : isFocused
                                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                    : null,
                                                                                                        color: isDisabled
                                                                                                            ? '#ccc'
                                                                                                            : isSelected
                                                                                                                ? '#24859A'
                                                                                                                : '#24859A',
                                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                                        ':active': {
                                                                                                            ...styles[':active'],
                                                                                                            background:
                                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                                        },
                                                                                                    };
                                                                                                },
                                                                                            }
                                                                                            :
                                                                                            {
                                                                                                ...styles,
                                                                                                control: (base, state) => ({
                                                                                                    ...base,
                                                                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                                                    border: '1px solid #bdbdbd', // default border color
                                                                                                    borderRadius: '6px',
                                                                                                    boxShadow: 'none', // no box-shadow
                                                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                                                    fontWeight: 'var(--app-regular-font-weight)',
                                                                                                    fontSize: 'var(--app-semi-small-font-size)'
                                                                                                }),
                                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                                    return {
                                                                                                        ...styles,
                                                                                                        fontFamily: 'var(--app-primary-font-style)',
                                                                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                                                                        fontSize: 'var(--app-semi-small-font-size)',
                                                                                                        background: isDisabled
                                                                                                            ? null
                                                                                                            : isSelected
                                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                : isFocused
                                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                    : null,
                                                                                                        color: isDisabled
                                                                                                            ? '#ccc'
                                                                                                            : isSelected
                                                                                                                ? '#24859A'
                                                                                                                : '#24859A',
                                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                                        ':active': {
                                                                                                            ...styles[':active'],
                                                                                                            background:
                                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                                        },
                                                                                                    };
                                                                                                },
                                                                                            }
                                                                                    }
                                                                                />

                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-3">
                                                                <Col>

                                                                    {isFilterLevelTwoAvailable &&
                                                                        <Row>
                                                                            <Col lg={3}>
                                                                                <p className={styles.defaultLabel}>Filter 1</p>
                                                                                {isLevelTwoFilterError && <p className={styles.errorMsg}>Required</p>}
                                                                            </Col>
                                                                            <Col>
                                                                                <Select
                                                                                    options={filterLevelTwoDropDownArray}
                                                                                    name="filter_level_two"
                                                                                    class="react-select__control"
                                                                                    components={animatedComponents}
                                                                                    value={values.filter_level_two}
                                                                                    onChange={(e) => { changeFilterLevelTwo(e.value); setFieldValue('filter_level_two', e.value) }}
                                                                                    styles={
                                                                                        isLevelTwoFilterError ?
                                                                                            {
                                                                                                ...styles,
                                                                                                control: (base, state) => ({
                                                                                                    ...base,
                                                                                                    '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                                                                    border: '1px solid #dc3545', // default border color
                                                                                                    borderRadius: '6px',
                                                                                                    boxShadow: 'none', // no box-shadow
                                                                                                }),
                                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                                    return {
                                                                                                        ...styles,
                                                                                                        background: isDisabled
                                                                                                            ? null
                                                                                                            : isSelected
                                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                : isFocused
                                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                    : null,
                                                                                                        color: isDisabled
                                                                                                            ? '#ccc'
                                                                                                            : isSelected
                                                                                                                ? '#24859A'
                                                                                                                : '#24859A',
                                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                                        ':active': {
                                                                                                            ...styles[':active'],
                                                                                                            background:
                                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                                        },
                                                                                                    };
                                                                                                },
                                                                                            }
                                                                                            :
                                                                                            {
                                                                                                ...styles,
                                                                                                control: (base, state) => ({
                                                                                                    ...base,
                                                                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                                                    border: '1px solid #bdbdbd', // default border color
                                                                                                    borderRadius: '6px',
                                                                                                    boxShadow: 'none', // no box-shadow
                                                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                                                    fontWeight: 'var(--app-regular-font-weight)',
                                                                                                    fontSize: 'var(--app-semi-small-font-size)'
                                                                                                }),
                                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                                    return {
                                                                                                        ...styles,
                                                                                                        fontFamily: 'var(--app-primary-font-style)',
                                                                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                                                                        fontSize: 'var(--app-semi-small-font-size)',
                                                                                                        background: isDisabled
                                                                                                            ? null
                                                                                                            : isSelected
                                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                : isFocused
                                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                                    : null,
                                                                                                        color: isDisabled
                                                                                                            ? '#ccc'
                                                                                                            : isSelected
                                                                                                                ? '#24859A'
                                                                                                                : '#24859A',
                                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                                        ':active': {
                                                                                                            ...styles[':active'],
                                                                                                            background:
                                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                                        },
                                                                                                    };
                                                                                                },
                                                                                            }
                                                                                    }
                                                                                />

                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                </Col>
                                                                <Col className={styles.filterBtnContainer}>
                                                                    <Col sm={6} className="pr-0">
                                                                        <CustomButton
                                                                            buttonType="submit"
                                                                            label="Apply Filters"
                                                                            type="defaultBtn"
                                                                        // disabled={((values.filter_level_one && values.filter_level_two && values.filter_level_three)||(values.filter_level_one && values.filter_level_two)) ? false : true}
                                                                        />
                                                                    </Col>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    }
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>
                        </Col>
                    </div>

                    <div className={styles.tableContainer}>
                        <MuiThemeProvider theme={theme}>
                            <MaterialTable
                                columns={[
                                    { title: '', render: rowData => rowData.state_code !== 0 ? <button className={styles.viewCandidateButton} onClick={() => viewCandidate(rowData.id)}><Icon component={eyeOpen} /></button> : <button className={styles.viewCandidateButton}><Icon component={eyeClose} /></button>, cellStyle: { minWidth: 10, width: 10, border: 'none' }, headerStyle: { minWidth: 10, width: 10 } },
                                    { title: 'NAME', field: 'name', render: rowData => rowData.name ? <div><p data-tip data-for={rowData.name + rowData._id} className="mb-0" onChange={addMaxViewLength(rowData.name, 30)}>{concatValue}</p><ReactTooltip id={((rowData.name).length > 30) ? (rowData.name + rowData._id) : ''} place="top" type="dark" effect="solid">{rowData.name}</ReactTooltip></div> : <p className={styles.pendingMsg}>N/A</p>, cellStyle: { minWidth: 250, width: 250, border: 'none' }, headerStyle: { minWidth: 250, width: 250 } },
                                    { title: 'EMAIL', field: 'email', render: rowData => <div><p className="mb-0" data-tip data-for={rowData.email + rowData._id} onChange={addMaxViewLength(rowData.email, 30)}>{concatValue}</p><ReactTooltip id={((rowData.email).length > 30) ? (rowData.email + rowData._id) : ''} place="top" type="dark" effect="solid">{rowData.email}</ReactTooltip></div>, cellStyle: { minWidth: 300, width: 300, border: 'none' }, headerStyle: { minWidth: 300, width: 300 } },
                                    { title: 'PHONE', field: 'phone', render: rowData => rowData.phone ? <p className="mb-0">{rowData.phone}</p> : <p className={styles.pendingMsg}>N/A</p>, cellStyle: { minWidth: 250, width: 250, border: 'none' }, headerStyle: { minWidth: 250, width: 250 } },
                                    { title: 'OVERALL MARKS', field: 'overall_marks', render: rowData => (rowData.overall_marks || rowData.overall_marks == 0) ? <p className="mb-0">{rowData.overall_marks}</p> : <p className={styles.pendingMsg}>N/A</p> },
                                    {
                                        title: 'STATUS', field: 'status', render: rowData =>
                                            rowData.state_code === 10 || rowData.state_code === 0 ?
                                                <Alert variant="warning" className={styles.pendingAlert}>{rowData.state}</Alert>
                                                : rowData.state_code === 20 ?
                                                    <Alert variant="success" className={styles.successAlert}>{rowData.state}</Alert>
                                                    : rowData.state_code === -10 ?
                                                        <Alert variant="danger" className={styles.failAlert}>{rowData.state}</Alert>
                                                        : rowData.state_code === -10 ?
                                                            <Alert variant="danger" className={styles.failAlert}>{rowData.state}</Alert>
                                                            : rowData.state_code === 30 ?
                                                                <Alert variant="success" className={styles.successAlert}>{rowData.state}</Alert>
                                                                : null
                                    },

                                ]}
                                data={filteredtableData}
                                isLoading={isDataLoading}
                                localization={{
                                    body: {
                                        emptyDataSourceMessage: <span>No records to display</span>
                                    },
                                    toolbar: {
                                        nRowsSelected: rowCount => <span className={styles.toolbarLabel}>{rowCount} row(s) selected</span>
                                    }
                                }}
                                actions={[
                                    (rowData) => {
                                        return { icon: dropdownIcon, iconProps: { color: 'disabled' } }
                                    },
                                ]}
                                components={{
                                    Action: rowData =>
                                    (

                                        <DropdownButton
                                            menuAlign="right"
                                            id="dropdown-menu-align-right"
                                            className={styles.actionBtn}
                                            title={
                                                <div className={styles.actionLabel}>
                                                    Actions&nbsp;
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.19995 7.59961L9.99995 12.3996L14.8 7.59961" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            }
                                        >
                                            {/* {tableActions.length > 0 ? */}
                                            <div>
                                                <div>
                                                    <Dropdown.Item className={styles.dropdownText} onClick={() => onActionSelected(SEND_BULK_EMAILS, rowData.data)}>{'Send Emails '}{isLoading && <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>}</Dropdown.Item>
                                                </div>


                                                {
                                                    tableActions.length > 0 ?
                                                        (
                                                            <>
                                                                <Dropdown.Divider />
                                                            </>
                                                        )
                                                        :
                                                        null
                                                }

                                                {tableActions.map((values, index) => (

                                                    <div key={index}>


                                                        <Dropdown.Item className={(values.action_id === MANUALLY_REJECT_IN_EVALUATION || values.action_id === REJECT_IN_FILTERD_STAGE) ? styles.dropdownTextCancel : styles.dropdownText} onClick={() => onActionSelected(values.action_id, rowData.data)}>{values.action_label}</Dropdown.Item>
                                                        {index !== ((tableActions.length) - 1) &&
                                                            <Dropdown.Divider />
                                                        }
                                                    </div>
                                                ))
                                                }
                                            </div>
                                            {/*
                                            // <div className={styles.actionsBodyComponent}>
                                            //     <span className={styles.actionsLable}>Actions Not Available</span>
                                            // </div>
                                            // */}
                                        </DropdownButton>
                                    )

                                }}
                                options={{
                                    maxBodyHeight: 350,
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor: (index % 2) ? '#EBF5FB' : '#FFFFFF',
                                        fontFamily: 'var(--app-primary-font-style)',
                                        fontSize: 'var(--app-primary-font-size)',
                                        fontWeight: 'var(--app-bold-font-weight)',
                                    }),
                                    cellStyle: (rowData, index) => ({
                                        border: 'none',
                                    }),
                                    headerStyle: {
                                        color: 'var(--app-primary-700-color)',
                                        fontSize: 'var(--app-primary-font-size)',
                                        fontWeight: 'var(--app-bold-font-weight)',
                                        fontFamily: 'var(--app-primary-font-style)',
                                        border: 'none',
                                        textTransform: 'uppercase'
                                    },
                                    showTitle: false,
                                    search: true,
                                    actionsColumnIndex: 0,
                                    isFreeAction: true,
                                    toolbar: true,
                                    showEmptyDataSourceMessage: true,
                                    pageSize: 10,
                                    selection: true,
                                    toolbarButtonAlignment: 'left'

                                }}
                            />
                        </MuiThemeProvider>
                    </div>
                </div>)
            }

        </div>
    )
}

export default ViewCandidates;
